import React from 'react';

interface IAppChipProps {
  color: string;
  letter: string;
  label: string;
  size?: number;
  logo?: string;
}

const AppChip = ({ color, letter, label, size = 28, logo }: IAppChipProps) => {
  if (logo) {
    return (
      <img
        src={logo}
        alt={label}
        style={{ width: size, height: size, borderRadius: 8, objectFit: 'cover', flexShrink: 0, display: 'block' }}
      />
    );
  }

  return (
    <div
      aria-label={label}
      style={{
        background: color,
        width: size,
        height: size,
        fontSize: Math.round(size * 0.42),
        borderRadius: 6,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 700,
        color: '#fff',
        flexShrink: 0,
      }}
    >
      {letter}
    </div>
  );
};

export default AppChip;
